export default (cbyoValue: number, maxMachinePrice: number) => {
  const cbyoNumber = Math.ceil(cbyoValue);
  return cbyoNumber > maxMachinePrice * 0.5
    ? Math.round(Math.max(maxMachinePrice, cbyoNumber * 1.5))
    : maxMachinePrice;
};
